import { useParams } from "react-router-dom";
import { useFetcher } from "~/hooks/useFetcher";
import { CeConfig } from "~/types/interfaces/ce-config";

const useConfigurations = () => {
  const { datasetId } = useParams();
  return useFetcher<CeConfig[]>(
    `/api/cohort-explorer/configurator/configs?dataset_id=${datasetId}`
  );
};

export default useConfigurations;
